import { Features } from '../constants/Features';

export interface IDowngradeDetailsPayload {
    targetLicenseName: string;
    targetLicenseCode: string;
    downgradeScheduledFor: string;
    importantFeaturesToLose: Array<{
        code: Features;
        maxQuantity: number;
    }>;
}

export interface IDowngradeDetailsFeature {
    code: Features;
    maxQuantity: number;
}

export class DowngradeDetails {
    private readonly _targetLicenseName: string;
    private readonly _targetLicenseCode: string;
    private readonly _downgradeScheduledFor: string;
    private readonly _importantFeaturesToLose: Array<IDowngradeDetailsFeature>;

    constructor(downgradeDetailsPayload: IDowngradeDetailsPayload) {
        this._targetLicenseName = downgradeDetailsPayload.targetLicenseName;
        this._targetLicenseCode = downgradeDetailsPayload.targetLicenseCode;
        this._downgradeScheduledFor = downgradeDetailsPayload.downgradeScheduledFor;
        this._importantFeaturesToLose = downgradeDetailsPayload?.importantFeaturesToLose;
    }

    get targetLicenseName(): string {
        return this._targetLicenseName;
    }

    get targetLicenseCode(): string {
        return this._targetLicenseCode;
    }

    get downgradeScheduledFor(): string {
        return this._downgradeScheduledFor;
    }

    get importantFeaturesToLose(): Array<IDowngradeDetailsFeature> {
        return this._importantFeaturesToLose;
    }
}
